var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHideNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_528_5",
    "data-name": "Component 528 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33810",
    "data-name": "Group 33810",
    transform: "translate(-602 -391.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M609.761,403.367a3.123,3.123,0,0,1-.925-2.229,3.16,3.16,0,0,1,5.394-2.241",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M615.1,401.7a3.158,3.158,0,0,1-2.537,2.542",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M606.655,406.472a13.429,13.429,0,0,1-3.905-5.335,13.591,13.591,0,0,1,3.934-5.365,8.257,8.257,0,0,1,10.652.019",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M619.448,397.991a15.358,15.358,0,0,1,1.8,3.146c-1.967,4.557-5.443,7.3-9.25,7.3a7.981,7.981,0,0,1-2.532-.413",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M619.887,393.25l-15.774,15.774",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13805",
    "data-name": "Rectangle 13805",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHideNew);
export default __webpack_public_path__ + "static/media/passwordHideNew.25c4b311.svg";
export { ForwardRef as ReactComponent };